import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import useAppVersion from '../../hooks/useAppVersion';

/**
 * アプリケーションのバージョン情報を表示するコンポーネント
 */
export const AppVersionDisplay: React.FC = () => {
  const { version, releaseDate, loading, error } = useAppVersion();
  // 読み込み中の場合
  if (loading) {
    return (
      <Typography variant="caption" color="text.secondary">
        Version: loading...
      </Typography>
    );
  }
  // エラーや不明な場合もバージョンを表示
  if (error || !version) {
    return (
      <Typography variant="caption" color="text.secondary">
        Version: {version || 'unknown'}
      </Typography>
    );
  }
  // リリース日時をフォーマット
  let formattedDate = '';
  try {
    if (releaseDate) {
      const date = new Date(releaseDate);
      formattedDate = date.toLocaleString('ja-JP', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  } catch (e) {
    console.error('日付のフォーマットに失敗:', e);
  }
  return (
    <Box>
      <Tooltip
        title={`リリース日時: ${formattedDate || '不明'}`}
        arrow
      >
        <Typography variant="caption" color="text.secondary" sx={{ display: 'inline' }}>
          Version: {version}
        </Typography>
      </Tooltip>
    </Box>
  );
};
export default AppVersionDisplay;
